import { useState, useEffect } from "react";
import PopUpModal from "../../shared/PopUpModal/PopUpModal";
import styles from "./RoomscenesPopup.module.css";

const ROOMSCENES_SERIES_ID = 9729;

export default function RoomscenesPopup({ isOpen, onClose, onSceneSelect }) {
    const [sceneData, setSceneData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('All');
    const [isLoading, setIsLoading] = useState(true);

    // Fetch roomscenes data
    useEffect(() => {
        if (isOpen) {
            setIsLoading(true);
            const URL = `https://lizard.chameleonpower.com/CDN/RoomScenes/${ROOMSCENES_SERIES_ID}.json`;
            fetch(URL)
                .then((response) => response.json())
                .then((data) => {
                    setSceneData(data);
                    // Extract unique productCategory values
                    const uniqueCategories = [...new Set(
                        data
                            .map(scene => scene.productCategory)
                            .filter(cat => cat && cat.trim() !== '')
                    )].sort();
                    setCategories(uniqueCategories);
                    setIsLoading(false);
                })
                .catch((error) => {
                    console.error('Error fetching roomscenes:', error);
                    setIsLoading(false);
                });
        }
    }, [isOpen]);

    // Reset selection when modal closes
    useEffect(() => {
        if (!isOpen) {
            setSelectedCategory('All');
        }
    }, [isOpen]);

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
    };

    const handleSceneClick = (scene) => {
        console.log('Roomscene clicked:', scene);
        if (onSceneSelect) {
            onSceneSelect(scene);
        }
    };

    // Filter scenes by selected category (show all if 'All' selected)
    const filteredScenes = selectedCategory === 'All'
        ? sceneData
        : sceneData.filter(scene => scene.productCategory === selectedCategory);

    if (!isOpen) return null;

    return (
        <PopUpModal
            handleClose={onClose}
            size="large"
            title="Select your roomscenes to begin"
            ariaLabelledBy="roomscenes-modal-title"
        >
            <div className={styles.container}>
                <p className={styles.subtitle}>Let's Start Visualizing</p>
                <h2 id="roomscenes-modal-title" className={styles.title}>
                    Select your roomscenes to begin
                </h2>

                {/* Filter buttons - always visible */}
                <div className={styles.filtersRow}>
                    <button
                        className={`${styles.filterButton} ${selectedCategory === 'All' ? styles.active : ''}`}
                        onClick={() => handleCategoryClick('All')}
                    >
                        All
                    </button>
                    {categories.map((category) => (
                        <button
                            key={category}
                            className={`${styles.filterButton} ${selectedCategory === category ? styles.active : ''}`}
                            onClick={() => handleCategoryClick(category)}
                        >
                            {category}
                        </button>
                    ))}
                </div>

                {/* Scenes grid */}
                {isLoading ? (
                    <div className={styles.loading}>Loading roomscenes...</div>
                ) : (
                    <div className={styles.scenesGrid}>
                        {filteredScenes.map((scene) => (
                            <button
                                key={scene.productId}
                                className={styles.sceneCard}
                                onClick={() => handleSceneClick(scene)}
                            >
                                <img
                                    src={`https://renderfarm2.chameleonpower.com/proxy/getImage.ashx?specifier=${scene.specifier}&size=300`}
                                    alt={scene.descriptor || 'Room scene'}
                                    className={styles.sceneImage}
                                />
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </PopUpModal>
    );
}
